export enum APP_BASE_PATHNAMES {
    'LOGIN' = 'login',
    'CONNECT' = 'connect',
    'SUBSCRIPTIONS' = 'subscriptions',
    'SUBSCRIPTION_DETAILS' = 'subscriptions/:subscriptionId'
}